import React from "react";
import { colors, spacing, typography, radius, btnPrimary, transitions } from "../utils/designTokens";

/**
 * Estado vacío unificado para cuando no hay datos.
 *
 * Props:
 * - icon (ReactElement): icono grande a mostrar
 * - title (string): mensaje principal
 * - description (string, opcional): mensaje secundario
 * - action ({ label, onClick }, opcional): botón de acción
 */
const EmptyState = ({ icon: Icon, title, description, action }) => {
  return (
    <div style={styles.container}>
      {Icon && (
        <div style={styles.iconWrap}>
          <Icon style={styles.icon} />
        </div>
      )}
      <p style={styles.title}>{title}</p>
      {description && <p style={styles.description}>{description}</p>}
      {action && (
        <button
          onClick={action.onClick}
          style={styles.actionBtn}
          className="habitia-btn-primary"
        >
          {action.icon && <span style={{ display: "flex" }}>{action.icon}</span>}
          {action.label}
        </button>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: `${spacing[12]}px ${spacing[6]}px`,
    textAlign: "center",
  },
  iconWrap: {
    width: 72,
    height: 72,
    borderRadius: radius.md,
    background: colors.gray100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: spacing[4],
  },
  icon: {
    fontSize: 32,
    color: colors.gray300,
  },
  title: {
    fontSize: typography.sizes.lg,
    fontWeight: 400,
    color: colors.gray900,
    margin: `0 0 ${spacing[2]}px`,
  },
  description: {
    fontSize: typography.sizes.md,
    color: colors.gray600,
    margin: 0,
    maxWidth: 360,
    lineHeight: 1.5,
  },
  actionBtn: {
    ...btnPrimary,
    marginTop: spacing[5],
    transition: `all ${transitions.fast}`,
  },
};

export default EmptyState;
